import REQUEST from './Request';
import { sanitizeLocationPayload } from '../utils/location';

// Session Management APIs
export const startSession = async (sessionData) => {
  console.log('Starting session with data:', sessionData);
  try {
    const response = await REQUEST({
      method: "POST",
      url: "SessionLog/start",
      data: sessionData,
    });
    console.log('Session start response:', response);
    return response;
  } catch (error) {
    console.error('Session start error:', error);
    throw error;
  }
};

export const endSession = async (sessionId, notes = '', locationData = {}) => {
  const locationPayload = sanitizeLocationPayload(locationData);

  return await REQUEST({
    method: "POST",
    url: "SessionLog/end",
    data: {
      sessionId,
      notes,
      ...locationPayload
    },
  });
};

export const getActiveSessions = async () => {
  return await REQUEST({
    method: "GET",
    url: "SessionLog/active",
  });
};

export const getSessionStatus = async () => {
  console.log('Getting session status...');
  try {
    const response = await REQUEST({
      method: "GET",
      url: "SessionLog/status",
    });
    console.log('Session status response:', response);
    return response;
  } catch (error) {
    console.error('Session status error:', error);
    throw error;
  }
};

export const getSessionHistory = async (sessionType = null) => {
  const url = sessionType 
    ? `SessionLog/history?sessionType=${sessionType}`
    : "SessionLog/history";
  
  return await REQUEST({
    method: "GET",
    url: url,
  });
};

export const getUserSessionStats = async () => {
  return await REQUEST({
    method: "GET",
    url: "SessionLog/stats",
  });
};

// Admin APIs (if needed)
export const getAdminSessionAnalytics = async (fromDate = null, toDate = null) => {
  let url = "SessionLog/admin/analytics";
  const params = [];
  
  if (fromDate) params.push(`fromDate=${fromDate}`);
  if (toDate) params.push(`toDate=${toDate}`);
  
  if (params.length > 0) {
    url += `?${params.join('&')}`;
  }
  
  return await REQUEST({
    method: "GET",
    url: url,
  });
};

export const getAllSessions = async (filters = {}) => {
  const params = new URLSearchParams();
  
  Object.keys(filters).forEach(key => {
    if (filters[key] !== null && filters[key] !== undefined) {
      params.append(key, filters[key]);
    }
  });
  
  const url = params.toString() 
    ? `SessionLog/admin/sessions?${params.toString()}`
    : "SessionLog/admin/sessions";
  
  return await REQUEST({
    method: "GET",
    url: url,
  });
};

export const getUserSessionStatsAdmin = async (userId) => {
  return await REQUEST({
    method: "GET",
    url: `SessionLog/admin/user-stats/${userId}`,
  });
};

// Feedback APIs
export const submitSessionFeedback = async (sessionId, feedbackData) => {
  console.log('Submitting session feedback:', { sessionId, feedbackData });
  try {
    const response = await REQUEST({
      method: "POST",
      url: "SessionLog/feedback",
      data: {
        sessionId,
        ...feedbackData
      },
    });
    console.log('Feedback submission response:', response);
    return response;
  } catch (error) {
    console.error('Feedback submission error:', error);
    throw error;
  }
};

export const getSessionFeedback = async (sessionId) => {
  return await REQUEST({
    method: "GET",
    url: `SessionLog/feedback/${sessionId}`,
  });
};

export const updateSessionFeedback = async (sessionId, feedbackData) => {
  return await REQUEST({
    method: "PUT",
    url: `SessionLog/feedback/${sessionId}`,
    data: feedbackData,
  });
};
